import { ReactElement, useRef } from 'react'
import { Checkbox } from '@machobear/design-system'
import { useField } from 'formik'

import useFocusOnError from '@/hooks/use-focus-on-error'

export const FieldCheckbox = (props: {
  name: string
  label: string
  onChange?: () => void
  required?: boolean
  disabled?: boolean
  checked: boolean
  badge: ReactElement
}) => {
  const fieldRef = useRef()
  const [field] = useField(props.name)
  const { onChange: formikOnChange } = field

  const { checked, name, label } = props
  useFocusOnError({ fieldRef, name })

  const onChangeField = (e: any) => {
    formikOnChange?.(e)
    props?.onChange?.()
  }

  return (
    <Checkbox
      id={name}
      name={name}
      checked={checked}
      onChange={onChangeField}
      label={label}
      badge={props.badge}
    />
  )
}
